import {ArrayUtils} from '@colonist/utils'
import {TranslationObject} from '@colonist/i18n'
import {
    BaseVictoryPointData, VictoryPointDataChit, VictoryPointDataCity, VictoryPointDataDefenderOfColonist, VictoryPointDataDevelopmentCard, VictoryPointDataLargestArmy, VictoryPointDataLongestRoad,
    VictoryPointDataMerchant, VictoryPointDataMetropolis, VictoryPointDataProgressCard, VictoryPointDataSettlement, VictoryPointTypes,
} from '@colonist/game-base-types'

export class VictoryPointDataController {
    static readonly victoryPointDataList: BaseVictoryPointData[] = [
        new VictoryPointDataSettlement(), new VictoryPointDataCity(), new VictoryPointDataDevelopmentCard(),
        new VictoryPointDataLargestArmy(), new VictoryPointDataLongestRoad(),

        new VictoryPointDataChit(),

        new VictoryPointDataMetropolis(), new VictoryPointDataDefenderOfColonist(),
        new VictoryPointDataProgressCard(), new VictoryPointDataMerchant(),
    ]

    static getEndGameVictoryPointImageFileNames(victoryPointTypes: VictoryPointTypes[]): string[] {
        const endGameImageFileName: string[] = []
        for(const victoryPoint of VictoryPointDataController.victoryPointDataList) {
            if(ArrayUtils.elementInArray(endGameImageFileName, victoryPoint.endGameImageFileName)) continue
            if(!ArrayUtils.elementInArray(victoryPointTypes, victoryPoint.victoryPointType)) continue
            endGameImageFileName.push(victoryPoint.endGameImageFileName)
        }
        return endGameImageFileName
    }

    static getEndGameVictoryPointToolTips(victoryPointTypes: VictoryPointTypes[]): TranslationObject[] {
        const endGameImageToolTips: TranslationObject[] = []
        for(const victoryPoint of VictoryPointDataController.victoryPointDataList) {
            if(ArrayUtils.elementInArray(endGameImageToolTips, {key: victoryPoint.endGameToolTipKey})) continue
            if(!ArrayUtils.elementInArray(victoryPointTypes, victoryPoint.victoryPointType)) continue
            endGameImageToolTips.push({key: victoryPoint.endGameToolTipKey})
        }
        return endGameImageToolTips
    }

    static getVictoryPointByType(victoryPointType: VictoryPointTypes): BaseVictoryPointData | undefined {
        for(const victoryPoint of this.victoryPointDataList) {
            if(victoryPoint.victoryPointType == victoryPointType) return victoryPoint.getNewInstanceOfData()
        }
        return undefined
    }
}
